import timezones from '@/data/timezones.json'
import { objToOpts } from '@/utils/opts'

const timezone = {
  state: {
    opts: {},
    inited: false
  },

  mutations: {
    INIT_TIMEZONE: (state, data) => {
      state.inited = true
      state.opts = objToOpts(data)
    }
  },

  actions: {
    InitTimezone ({ commit }) {
      if (this.state.timezone.inited) {
        return new Promise((resolve) => {
          resolve(this.state.timezone.opts)
        })
      }
      return new Promise((resolve, reject) => {
        commit('INIT_TIMEZONE', timezones)
        resolve(this.state.timezone.opts)
      })
    },
    ResetTimezone ({ commit }) {
      // do nothing
    }
  }
}

export default timezone
